export default __webpack_public_path__ + "static/media/GameBoard.2b9a7984.png";